// extracted by mini-css-extract-plugin
export var actions = "_4d-0";
export var actionsContainer = "_4d-8";
export var border = "_4d-1";
export var childFullHeight = "_4d-f";
export var collapse = "_4d-2";
export var content = "_4d-a";
export var contentChild = "_4d-e";
export var fullscreen = "_4d-c";
export var hasLeftRadius = "_4d-r";
export var headerContainer = "_4d-3";
export var headerRow = "_4d-5";
export var hidePadding = "_4d-b";
export var navCollapsedGap = "_4d-s";
export var noScrollX = "_4d-t";
export var noScrollY = "_4d-u";
export var noTopPadding = "_4d-p";
export var optOutTopPadding = "_4d-d";
export var outletContent = "_4d-l";
export var outletContentInner = "_4d-m";
export var outletLeadingPanel = "_4d-i";
export var outletLeadingPanelAttention = "_4d-j";
export var outletNoScroll = "_4d-7";
export var outletResizeDivider = "_4d-k";
export var outletSplit = "_4d-g";
export var outletSplitResizing = "_4d-h";
export var pageMain = "_4d-q";
export var pageOuter = "_4d-n";
export var pagePadding = "_4d-9";
export var profile = "_4d-v";
export var profileContainer = "_4d-w";
export var profileImage = "_4d-x";
export var profileMain = "_4d-y";
export var profileSubtitle = "_4d-10";
export var profileTitle = "_4d-z";
export var showLeftPadding = "_4d-o";
export var tabsPortalSlot = "_4d-6";
export var tabsWrapper = "_4d-4";
export var title = "_4d-11";